import { Delete, Edit, Visibility } from "@mui/icons-material";
import {
    Alert,
    CircularProgress,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { useEffect, useState } from "react";
import {
    designersReset,
    DeleteDesignerAction,
    GetAllDesigners,
} from "../../Redux/DesignerSlice/DesignerSlice";
import { DeleteModal } from "../../Components/Modal/Modals";
import { toast } from "react-toastify";

import DesignerLicenseShow from "./DesignerLicenseShow";

const AllDesigners = () => {
    const dispatch = useDispatch();
    const { designers, isLoading } = useSelector((state) => state.designers);
    const designersData = designers?.data || [];
    console.log(designersData);
    const designerPag = designers?.data;

    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(20);

    const [designerLicense, setDesignerLicense] = useState(0);
    const handelShowDesignerLicense = (id) => {
        id === designerLicense ? setDesignerLicense(0) : setDesignerLicense(id);
    };

    // Delete designer Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [tableId, setTableId] = useState(null);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        await toast.success(" designer deleted success");
        await GetDesigners();
        await dispatch(designersReset());
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteDesignerAction(data.id));
        await CallNotificationMethod();
        await setTableId(data.id);
    };
    const handelDeleteDesigner = async (data) => {
        handleOpen(data);
    };

    // // Filter By Fields Variables
    // const [name, setName] = useState("");
    // const [address, setAddress] = useState("");
    // const [status, setStatus] = useState("");
    // const [entity, setEntity] = useState("");
    // const [license, setLicense] = useState("");
    // const [initial, setInitial] = useState("");
    // const [state, setState] = useState("");

    // const searchObj = {
    //     name,
    //     address,
    //     status,
    //     entity,
    //     license,
    //     initial,
    //     state,
    // };

    // const handelFilterAction = async (object_search = null) => {
    //     await dispatch(
    //         SearchONDesigners({ ...object_search, paginate: rowsPerPage })
    //     );
    //     await dispatch(designersReset());
    // };

    // const handelResetData = () => {
    //     setName("");
    //     setAddress("");
    //     setStatus("");
    //     setEntity("");
    //     setLicense("");
    //     setInitial("");
    //     setState("");
    //     handelFilterAction();
    // };

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);

    //     const callSearchAction = async () => {
    //         await dispatch(
    //             SearchONDesigners({
    //                 ...searchObj,
    //                 paginate: rowsPerPage,
    //                 page: newPage + 1,
    //             })
    //         );
    //         await dispatch(designersReset());
    //     };
    //     callSearchAction();
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value));
    //     setPage(0);
    //     const callSearchAction = async () => {
    //         await dispatch(
    //             SearchONDesigners({
    //                 ...searchObj,
    //                 paginate: event.target.value,
    //             })
    //         );
    //         await dispatch(designersReset());
    //     };
    //     callSearchAction();
    // };

    // function inputKeyUp(e) {
    //     e.which = e.which || e.keyCode;
    //     if (e.which === 13) {
    //         handelFilterAction(searchObj);
    //     }
    // }

    const GetDesigners = async () => {
        await dispatch(GetAllDesigners());
        await dispatch(designersReset());
    };

    useEffect(() => {
        GetDesigners();
    }, []);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        {/* <TableHeadStyled>
                                        <TableRow>
                                            <TableCell style={{ padding: "5px" }}>
                                                Filter By :
                                            </TableCell>
                                            <TableCell
                                                style={{ padding: "5px" }}
                                                width={500}
                                            >
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="name"
                                                        name="name"
                                                        label="Name"
                                                        value={name}
                                                        onKeyUp={(e) => inputKeyUp(e)}
                                                        onChange={(e) => {
                                                            setName(e.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </TableCell>
                                            <TableCell style={{ padding: "5px" }}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="address"
                                                        name="address"
                                                        label="Address"
                                                        value={address}
                                                        onKeyUp={(e) => inputKeyUp(e)}
                                                        onChange={(e) => {
                                                            setAddress(e.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </TableCell>
            
                                            <TableCell style={{ padding: "5px" }}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="email"
                                                        name="email"
                                                        label="Email"
                                                        value={email}
                                                        onKeyUp={(e) => inputKeyUp(e)}
                                                        onChange={(e) => {
                                                            setEmail(e.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </TableCell>
            
                                            <TableCell style={{ padding: "5px" }}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="company_name"
                                                        name="company_name"
                                                        label="Coname"
                                                        value={company_name}
                                                        onKeyUp={(e) => inputKeyUp(e)}
                                                        onChange={(e) => {
                                                            setConame(e.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </TableCell>
            
                                            <TableCell style={{ padding: "5px" }}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="phone"
                                                        name="phone"
                                                        label="Phone"
                                                        value={phone}
                                                        onKeyUp={(e) => inputKeyUp(e)}
                                                        onChange={(e) => {
                                                            setPhone(e.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </TableCell>
            
                                            <TableCell style={{ padding: "5px" }}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="rate"
                                                        name="rate"
                                                        label="Rate"
                                                        value={rate}
                                                        onKeyUp={(e) => inputKeyUp(e)}
                                                        onChange={(e) => {
                                                            setRate(e.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </TableCell>
                                            <TableCell
                                                style={{ padding: "5px" }}
                                                align="center"
                                            >
                                                <Grid container coulmns={12}>
                                                    <Button
                                                        style={{ marginBottom: "5px" }}
                                                        fullWidth
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={(e) =>
                                                            handelFilterAction(searchObj)
                                                        }
                                                    >
                                                        <FilterAltIcon></FilterAltIcon>
                                                    </Button>
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        color="error"
                                                        onClick={(e) => handelResetData()}
                                                    >
                                                        <RestartAltIcon></RestartAltIcon>
                                                    </Button>
                                                </Grid>
                                            </TableCell>
                                        </TableRow>
                                    </TableHeadStyled> */}

                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Plan Price</TableCell>
                                <TableCell>
                                    Structure Calculation Price
                                </TableCell>
                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {designersData?.map((designer, index) => (
                                <>
                                    <TableRowStyled key="{designer.id}">
                                        <TableCellStyle>
                                            {/* {rowsPerPage * page + index + 1} */}
                                            {index + 1}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {designer.name}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {designer.email}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {designer.phone}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {designer.plan_price}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {
                                                designer.structure_calculation_price
                                            }
                                        </TableCellStyle>

                                        <TableCellStyle align="center">
                                            <IconButton>
                                                <Link
                                                    to={"edit=" + designer.id}
                                                >
                                                    <Edit color="success" />
                                                </Link>
                                            </IconButton>
                                            <IconButton
                                                onClick={() =>
                                                    handelDeleteDesigner(
                                                        designer
                                                    )
                                                }
                                            >
                                                {tableId === designer.id && (
                                                    <ProgressStyled>
                                                        <CircularProgress
                                                            size={30}
                                                            color="error"
                                                        />
                                                    </ProgressStyled>
                                                )}

                                                <ProgressStyled>
                                                    <Delete color="error" />
                                                </ProgressStyled>
                                            </IconButton>
                                            {designer.designer_licenses &&
                                                designer.designer_licenses
                                                    .length !== 0 && (
                                                    <IconButton
                                                        onClick={(e) =>
                                                            handelShowDesignerLicense(
                                                                designer.id
                                                            )
                                                        }
                                                    >
                                                        <Visibility color="primary" />
                                                    </IconButton>
                                                )}
                                        </TableCellStyle>
                                    </TableRowStyled>
                                    {designer.designer_licenses &&
                                        designer.designer_licenses.length !==
                                            0 &&
                                        designerLicense === designer.id && (
                                            <>
                                                <DesignerLicenseShow
                                                    license={
                                                        designer.designer_licenses
                                                    }
                                                ></DesignerLicenseShow>
                                            </>
                                        )}
                                </>
                            ))}
                        </TableBody>

                        {/* {designerPag.total >= 20 && (
                            <TablePagination
                                rowsPerPageOptions={[
                                    designerPag.total,
                                    designerPag.total * 4,
                                    designerPag.total * 6,
                                    { label: "All", value: -1 },
                                ]}
                                colSpan={12}
                                count={designerPag.total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )} */}
                    </Table>

                    {designerPag?.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}

                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                    
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllDesigners;
